import React from "react";
import { AnnouncementBar } from "./components/AnnouncementBar";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { TrustBadges } from "./components/TrustBadges";
import { PainSection } from "./components/PainSection";
import { SolutionSection } from "./components/SolutionSection";
import { WhatYouGet } from "./components/WhatYouGet";
import { Bonuses } from "./components/Bonuses";
import { Testimonials } from "./components/Testimonials";
import { AuthorSection } from "./components/AuthorSection";
import { PriceSection } from "./components/PriceSection";
import { Guarantee } from "./components/Guarantee";
import { FAQ } from "./components/FAQ";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import { StickyCTA } from "./components/StickyCTA";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { ExitIntentPopup } from "./components/ExitIntentPopup";
export function App() {
  return <div className="min-h-full w-full bg-[#0a0a1f] pb-16" data-id="element-0" data-mp="3ikqwhsrnks2k">
      <AnnouncementBar data-id="element-1" data-mp="3mlja0y7k5j4n" />
      <Header data-id="element-2" data-mp="3ml12h5fg3ihf" />
      <main data-id="element-3" data-mp="3mkhm3t5g125i">
        <Hero data-id="element-4" data-mp="3mk83iqmq9x9u" />
        <TrustBadges data-id="element-5" data-mp="3mjq3diwy2ywn" />
        <PainSection data-id="element-6" data-mp="3mj6lu3b7icj5" />
        <SolutionSection data-id="element-7" data-mp="3rbrakqf99zft" />
        <WhatYouGet data-id="element-8" data-mp="3rdkhm6ts6loc" />
        <Bonuses data-id="element-9" data-mp="3rd19tixuhdo1" />
        <Testimonials data-id="element-10" data-mp="3relvej26lm9r" />
        <AuthorSection data-id="element-11" data-mp="5opww5kum4f" />
        <PriceSection data-id="element-12" data-mp="4wx1t3d72hu" />
        <Guarantee data-id="element-13" data-mp="56nfhsbnbo2" />
        <FAQ data-id="element-14" data-mp="7suzhf7pr6a" />
        <FinalCTA data-id="element-15" data-mp="2zl3cxocsjc6w" />
      </main>
      <Footer data-id="element-16" data-mp="2zm4yimrfnh2v" />

      <StickyCTA data-id="element-17" data-mp="2zmem63p09c5e" />
      <WhatsAppButton data-id="element-18" data-mp="2zmwl5831y4h0" />
      <ExitIntentPopup data-id="element-19" data-mp="33mow1rfx4mpj" />
    </div>;
}